import gsap from '@ptchr/gsap/all';
// gsap.registerPlugin(CSSRulePlugin)

window.addEventListener('load', () => {
	const counters = document.querySelectorAll('.count')
	counters.forEach(counter => {
		// const start = counter.getAttribute('data-counter-start')
		const end = counter.getAttribute('data-counter-end')
		const time = counter.getAttribute('data-counter-time')

		countAnimation(counter.querySelector('.value'), end, time)
	});
})

const countAnimation = (el, end, time) => {
	time = time ? time : 2
	let sign = '';

	if (/^(\d+|(\.\d+))(\.\d+)?%$/.test(end)) {
		end = end.replace('%', '')
		sign = '%'
	}

	end = end.match(/^-?[0-9]\d*(\.\d+)?$/g)
	var tl = gsap.timeline({
		scrollTrigger: {
			trigger: el,
			start: 'center bottom',
			end: 'center top'
		}
	});

	tl.to(el, {
		duration: time,
		ease: 'none',
		innerText: end + sign,
		roundProps: 'innerText'
	}, '<');
}



// WEBPACK FOOTER //
// ./js/modules/animations/stats.js